import React, { useState } from 'react';
import { Collapse } from 'components/Transition';

import './style.scss';

export interface AccordionProps {
    title?: any;
    children?: any[];
    open?: boolean;
}

const Accordion: React.FC<AccordionProps> = props => {
    const [open, setOpen] = useState(props.open || false);

    const handleClick = () => {
        setOpen(!open);
    };

    return (
        <div className="accordion-root">
            <div className="title-container" onClick={handleClick}>
                {props.title}
            </div>
            <Collapse in={open}>
                <div className="children-container">{props.children}</div>
            </Collapse>
        </div>
    );
};

export default Accordion;
